
class RequestShipmentServices {
    async paginator(filterModel, params, laboratoryId, url) {
        const response =
            await this.axios.put(
                `/shipment/laboratories/${laboratoryId}/shipmentRequests/${url}`,
                filterModel,
                { params })
        return response.data
    }

    async createShippingRequest(request, laboratoryId) {
        const response =
            await this.axios.post(
                `/shipment/laboratories/${laboratoryId}/shipmentRequests`,
                request)
        return response.data
    }
}
export const requestShipmentServices = new RequestShipmentServices()
